import {
    List
} from "@mui/material";
import DrawerListItems from "./DrawerListItems";
import { useOrganizationContext } from "../OrganizationContext";

const DrawerSpecificContent = ({ data, collapsed }) => {
    const organizationContext = useOrganizationContext();
    const filterPredicate = ((value) => !value.common);
    
    // Hide specific content if dashboard is organization context aware and user has no memberships
    if (organizationContext?.isOrganizationContextAware && !organizationContext?.hasMemberships) {
        return null;
    }
    
    return (
        <List>
            <DrawerListItems data={data} filterPredicate={filterPredicate} collapsed={collapsed} />
        </List>
    )
}
export default DrawerSpecificContent